/* eslint-disable arrow-body-style */
import React from "react"
import RowComponent from "./components/RowComponent"

const DetailedReport = ({ detailedRows, reloadData }) => {
  const {
    days, name, total, total_target, total_target_completed_percentage, total_operation_value
  } = detailedRows

  return (
    <div className="my-5">
      <h5>{name}</h5>
      <div className="table-responsive">
        <table className="table table-listing table-hover table-striped">
          <thead>
            <tr>
              <th>Booking Time</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Duration</th>
              <th>Date And Time Sent to Drafting</th>
              <th>Address</th>
              <th>Type</th>
              <th>Percentage</th>
              <th>Price</th>
              <th>Operation value</th>
            </tr>
          </thead>
          <tbody>
            <RowComponent days={days} reloadData={reloadData} />
            <tr className="font-weight-bold text-white bg-dark" style={{ backgroundColor: "#343a40" }}>
              <td colSpan={5}></td>
              <td className="text-right">Target:</td>
              <td>{total_target}</td>
              <td>{`${total_target_completed_percentage}%`}</td>
              <td className="text-right">{total}</td>
              <td className="text-right">{total_operation_value}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DetailedReport